<template>
  <div class="grey lighten-3 fill-height">
    <v-container fluid no-gutters class="pa-0">
      <v-app-bar height="100">
        <v-container>
          <v-toolbar-title>
            <v-img
              lazy-src="@/assets/logo.png"
              src="@/assets/logo.png"
              style="left: -0.5em"
              max-width="120px"
            ></v-img
          ></v-toolbar-title>
        </v-container>
      </v-app-bar>
    </v-container>
    <v-container>
      <v-row>
        <v-col cols="12" md="6">
          <stepper :steps="2" :stepText="stepTexts" :currentStep="step" />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12" md="6">
          <transition-group
            tag="div"
            class="stepper-slider"
            name="slide"
            mode="out-in"
          >
            <!-- STEP 1 -->
            <v-form
              key="formCadastro"
              v-if="step === 0"
              class="mt-5"
              ref="formCadastro"
              @submit="cadastroSubmit"
            >
              <v-row>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    v-model="userData.produto"
                    :items="productList"
                    item-text="nome"
                    item-value="idResidencia"
                    label="Produto"
                    @change="
                      getPlanListPublic({ residencia: userData.produto })
                    "
                    :rules="required"
                  ></v-select>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                    outlined
                    v-model="userData.nome"
                    label="Nome"
                    :rules="required"
                  ></v-text-field>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    v-model="userData.cpf"
                    label="CPF:"
                    v-mask="['###.###.###-##']"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    v-model="userData.celular"
                    label="Celular"
                    v-mask="['(##) #####-####']"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="12">
                  <v-text-field
                    outlined
                    v-model="userData.email"
                    label="Email"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    cols="12"
                    md="3"
                    name="input-10-2"
                    label="Nova senha"
                    class="input-group--focused"
                    @click:append="show = !show"
                    v-model="userData.senha"
                    :rules="required"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-text-field
                    outlined
                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                    :type="show ? 'text' : 'password'"
                    cols="12"
                    md="3"
                    name="input-10-2"
                    label="Repetir nova senha"
                    class="input-group--focused"
                    @click:append="show = !show"
                    v-model="userData.senhaRepetir"
                    :rules="[passwordConfirmation]"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" md="6">
                  <v-select
                    outlined
                    v-model="userData.plano"
                    :items="planList"
                    label="Plano"
                    :rules="required"
                    item-text="nome"
                    item-value="idPlano"
                  ></v-select>
                </v-col>
              </v-row>
              <v-row> </v-row>
              <v-row class="text-center">
                <v-col>
                  <v-btn block color="indigo" dark @click="cadastroSubmit"
                    >Continuar</v-btn
                  >
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col>
                  <div class="separator">ou</div>
                </v-col>
              </v-row>
              <v-row class="text-center">
                <v-col>
                  <v-btn color="blue" rounded large dark @click="cadastroSubmit"
                    >PAGUE COM PAYPAL</v-btn
                  >
                </v-col>
              </v-row>
            </v-form>
            <!-- STEP 2 -->
            <!-- <div class="mt-5" key="formPagamento" v-if="step === 1">
              <p class="mt-5">Pagamento</p>
              <v-btn @click="step++">Próximo passo</v-btn>
            </div> -->
            <!-- STEP 3 -->
            <div key="complete" v-if="step === 1" class="cadastro-sucesso">
              <h3 class="indigo--text">Cadastro realizado com sucesso!</h3>
              <p class="mt-5">
                Seja bem vindo ao MedCof, faça seu login com e-mail e senha
                cadastrados e tenha acesso a todo nosso conteúdo.
              </p>
              <v-btn @click="$router.push('/')" class="mt-5 indigo white--text"
                >LOGIN</v-btn
              >
            </div>
          </transition-group>
        </v-col>
        <v-col cols="12" md="6" v-if="!!userData.produto">
          <div class="d-flex justify-center mt-5">
            <v-img
              max-height="500px"
              max-width="500px"
              width="100%"
              content-class="responsive-img"
              v-if="userData.produto === 2"
              src="@/assets/banner_R1.png"
              contain
            ></v-img>
            <v-img
              max-height="500px"
              max-width="500px"
              width="100%"
              content-class="responsive-img"
              v-else
              src="@/assets/banner_R3.png"
              contain
            ></v-img>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
  import Stepper from '../../components/shared/Stepper.vue';
  import { mapActions, mapState } from 'vuex';

  export default {
    components: {
      Stepper,
    },

    data() {
      return {
        step: 0,
        stepTexts: [
          'Dados Pessoais',
          // "Informações de Pagamento",
          `Acesse o Curso`,
        ],
        show: false,
        required: [(v) => !!v || 'Este campo é obrigatório'],
        samePassword: [
          (v) => v === this.getUserPassword() || 'As senhas estão diferentes',
        ],
        paymentMethods: [],
        userData: {
          nome: '',
          celular: '',
          email: '',
          senha: '',
          senhaRepetir: '',
          cpf: '',
          plano: '',
          // formaPagamento: "",
          produto: '',
        },
      };
    },

    computed: {
      ...mapState('plan', ['planList']),
      ...mapState('product', ['productList']),
      getUserPassword() {
        return this.userData.senha;
      },
      passwordConfirmation() {
        return (
          this.userData.senha === this.userData.senhaRepetir ||
          'As senhas estão diferentes'
        );
      },
      getProductImage() {
        return this.userData.produto.idResidencia === 2
          ? `banner_R1.png`
          : 'banner_R3.png';
      },
    },

    methods: {
      ...mapActions('user', ['createNewUserPublic']),
      ...mapActions('plan', ['getPlanListPublic']),
      ...mapActions('product', ['getProductListPublic']),
      async cadastroSubmit() {
        const validate = await this.$refs.formCadastro.validate();
        if (!validate) return;
        this.createNewUserPublic(this.userData).then((status) => {
          status === 200 && this.step++;
        });
      },
    },

    mounted() {
      this.getProductListPublic();
    },
  };
</script>

<style lang="scss" scoped>
  .slide-enter-active,
  .slide-leave-enter {
    transform: translateX(0);
    transition: all 0.5s linear;
  }
  .slide-enter,
  .slide-leave-to {
    transform: translateX(100%);
  }
  .stepper-slider {
    overflow: hidden;
    position: relative;
    width: 100%;
    height: 100%;
  }

  .separator {
    display: flex;
    align-items: center;
    text-align: center;
  }
  .separator::before,
  .separator::after {
    content: '';
    flex: 1;
    border-bottom: 1px solid #000;
  }
  .separator::before {
    margin-right: 0.25em;
  }
  .separator::after {
    margin-left: 0.25em;
  }
  .responsive-image {
    .v-responsive__content {
      max-width: 100% !important;
    }
  }
</style>
